module.exports = __webpack_public_path__ + "img/party.9cbbb6d0.jpg";